var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 17.859 17.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_06_logout_px18",
    transform: "translate(0.225 0.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_logout",
    "data-name": "Icon/logout"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 16.976,
    height: 16.976,
    transform: "translate(0.333 0.565)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M394.331,124.887c-.3,0-.548.006-.548.305v2.769h-9.428V112.589h9.428v2.887c0,.3.246.327.548.327s.548-.028.548-.327v-3.429a.545.545,0,0,0-.548-.542H383.806a.545.545,0,0,0-.548.542V128.5a.545.545,0,0,0,.548.542h10.525a.545.545,0,0,0,.548-.542v-3.311C394.879,124.894,394.633,124.887,394.331,124.887Z",
    transform: "translate(-383.258 -111.505)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M398.961,122.408c0-.006.005-.012.01-.018a.51.51,0,0,0,.069-.109.422.422,0,0,0,.012-.041.542.542,0,0,0,.016-.056.554.554,0,0,0,.015-.143c0-.016,0-.031,0-.048a.557.557,0,0,0-.052-.18c-.005-.01-.014-.02-.02-.03a.575.575,0,0,0-.061-.092l-2.844-3.2c-.2-.227-.478-.082-.7.119s-.317.383-.116.609l2.034,2.289h-8.249c-.3,0-.311.229-.311.533s.008.563.311.563h8.3l-2.038,2.442c-.194.233,0,.508.23.7a.545.545,0,0,0,.351.127c.156,0,.153,0,.261-.127Z",
    transform: "translate(-381.674 -113.436)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.45
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.f067f35e5907e2139b96953d59d3ce71.svg";
export { ForwardRef as ReactComponent };